<!-- 分时图 -->
<!-- TODO 分时图成交量一行文字影响布局，图表会溢出，记得找人看下 -->
<template>
  <div class="time-chart-box">
    <fund-chart-legend
      :is-touched="isTouched"
      :line-chart-type="'timeSharing'"
      :legend-value-list="legendValueList"/>
    <div class="time-chart-padding">
      <div class="time-chart-container" id="time-chart-container">
        <time-sharing-chart
          :auto-init="false"
          :config="config"
          :request-data="getData"
          @afterRender="handleAfterRender"
          @onChangeToolTip="toolTipChange"
          @onHideToolTip="toolTipHide"
          ref="chart"/>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeSharingChart } from '@fund/f2-chart-h5';
import FundChartLegend from './FundChartLegend.vue';

export default {
  name: 'timing-sharing-chart',

  components: {
    FundChartLegend,
    TimeSharingChart,
  },

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      chartWidth: 0, // 图表宽度
      chartHeight: 0, // 图表高度
      legendValueList: [], // 图例数据
      originLegendList: [], // 初始图例数据
      isTouched: false, // 是否长按
    };
  },

  computed: {
    config() { // 图表配置
      return {
        // 图表宽度
        lineChart: {
          width: this.chartWidth,
          height: 200,
          yAxisConfig: {
            tipFormatter: (value) => (`${parseFloat(value)?.toFixed(3) || '--'}`),
          },
        },
        barChart: {
          width: this.chartWidth,
          height: 80,
          xAxisConfig: {
            tipFormatter: (value) => (this.$isEmpty(value) ? '--' : value?.split(' ')[1] || '--'),
          },
        },
        xAxisConfig: {
          tipFormatter: (value) => (this.$isEmpty(value) ? '--' : value?.split(' ')[1] || '--'),
        },
        throttleTime: 300,
      };
    },
  },

  mounted() {
    setTimeout(() => {
      const boxEle = document.getElementById('time-chart-container');
      this.chartWidth = boxEle.offsetWidth;
      this.chartHeight = boxEle.offsetHeight;
      this.$refs.chart.start();
    }, 1500);
  },

  methods: {

    // 获取分时图数据
    async getData() {
      const wbp2u = '';
      const reqParams = {
        secid: this.basicInfo?.isGoldFund ? `118.${this.detailInfo?.indexCode || 'AU9999'}`
          : `${this.detailInfo?.newMarketCode || 0}.${this.fundCode}`,
        fields1: 'f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f11,f12,f13,f14',
        fields2: 'f51,f52,f53,f54,f55,f56,f57,f58',
        iscr: 0,
        iscca: 0,
        ut: 'a7202e6f901554f7cfadffa430c882bf',
        ndays: 1,
        dpt: 'ttjj.xtb',
        wbp2u,
      };
      const res = await this.$http.useRequests('StokeApi.getTimeShareData', reqParams)
        .catch((err) => { console.log('getTimeShareData ERR', err); });
      console.log('===> getTimeShareData', res);
      return res.data || {};
    },

    // 处理图例数据
    handleAfterRender(data) {
      console.log('===> handleAfterRender', data);
      if (!this.$isEmpty(data) && data.length) {
        const lastIndex = data?.findLastIndex((item) => !this.$isEmpty(item.price));
        const lastPoint = data[lastIndex] || {};
        const {
          date, price, rise, volume,
        } = lastPoint;
        this.legendValueList = [{
          date,
          type: 'price-point',
          value: price,
        }, {
          date,
          type: 'volume-point',
          value: volume,
        }, {
          date,
          type: 'rise-point',
          value: rise,
        }];
        this.originLegendList = this.legendValueList;
        console.log('===> this.legendValueList', this.legendValueList);
      }
    },

    // 长按移动
    toolTipChange(params) {
      const {
        date, price, volume, rise,
      } = params;
      this.legendValueList = [{
        date,
        type: 'price-point',
        value: price,
      }, {
        date,
        type: 'volume-point',
        value: volume,
      }, {
        date,
        type: 'rise-point',
        value: rise,
      }];
      this.isTouched = true;
    },

    toolTipHide() {
      this.legendValueList = this.originLegendList;
      this.isTouched = false;
    },
  },

};
</script>

<style lang="less" scoped>

.time-chart-box {
  margin: 24px 0;
  // padding: 0 24px;
  box-sizing: border-box;
  // background-color: aliceblue;
  .time-chart-padding {
    padding: 0 24px;
  }
  .time-chart-container {
    width: 100%;
    box-sizing: border-box;
    // height: 400px;
  }
}
</style>
